import React from 'react';
import { Capacitor } from '@capacitor/core';
import { NativeSettings, AndroidSettings, IOSSettings } from 'capacitor-native-settings';
import styled from 'styled-components';
import { Outline } from '../button';
import { trackInsightsException } from '../../utils/telemetry/appinsights';
import { didOpenNativeSettings } from '../../utils/nativeSettingsUtils';

export const LocationSettingsButton: React.FC<{ onClickAction?: () => void }> = ({ onClickAction }) => {
  const [isLoading, setIsLoading] = React.useState(false);

  const handleOnClick = async (): Promise<void> => {
    if (Capacitor.isNativePlatform()) {
      if (onClickAction !== undefined) {
        onClickAction();
      }

      setIsLoading(true);

      const result = await NativeSettings.open({
        optionAndroid: AndroidSettings.ApplicationDetails,
        optionIOS: IOSSettings.App,
      });

      if (!didOpenNativeSettings(result)) {
        trackInsightsException('CAPACITOR_APP_FAILED_TO_OPEN_APP_SETTINGS', 'NativeSettings.open reported failure');
      }

      setIsLoading(false);
    }
  };

  return (
    <StyledOutlineButton onClick={handleOnClick} loading={isLoading}>Avaa asetukset</StyledOutlineButton>
  );
}

const StyledOutlineButton = styled(Outline)`
  background-color: transparent;

  &:hover,
  &:focus-visible {
    background-color: transparent;
  }
`;
